
import { Component, Prop, Vue } from "vue-property-decorator";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";
import { DynamicField } from "@/types/dynamic-data";
import { DynamicFieldReturnType } from "@/types/dynamic-property-path";
import { configStore } from "@/store/store-accessor";
import { getProBadge } from "@/lib/subscriptions/free-mode";
import ElementBadge from "@/components/ElementPropertiesPanel/ElementBadge.vue";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import IconChooserDialog from "@/components/Reusable/CustomInputs/IconInput/IconChooserDialog.vue";
import { writeToClipboard } from "@/lib/copy-paste/copy-paste";
import { getShortcodeFromDynamicField } from "@/lib/dynamic-data/utils";

@Component({
  components: {
    IconChooserDialog,
    Dropdown,
    TextInput,
    DropdownInput,
    ElementBadge
  }
})
export default class DynamicDataField extends Vue {
  @Prop()
  field!: DynamicField;

  @Prop()
  active!: boolean;

  @Prop()
  selected!: boolean;

  @Prop()
  accepts!: DynamicFieldReturnType | false;

  get normalizedReturnTypes() {
    return this.field.returnTypes
      .map(returnType => this.normalize(returnType))
      .join(", ");
  }

  get proOnlyField() {
    return this.field.proOnly && configStore.subscriptionMode === "free";
  }

  get proBadge() {
    return getProBadge();
  }

  get normalizedAccepts() {
    return this.normalize(this.accepts || "");
  }

  normalize(text: string) {
    return text.replace("_", " ");
  }

  contextMenuOpen = false;
  contextMenuX = 0;
  contextMenuY = 0;

  openContextMenu(e: MouseEvent) {
    this.contextMenuX = e.clientX;
    this.contextMenuY = e.clientY;

    this.contextMenuOpen = true;
  }

  copy() {
    const shortcode = getShortcodeFromDynamicField({}, this.field);

    writeToClipboard(shortcode);
  }
}
